var EXLY_WEBAPP_URL_SEARCH_PARAMS = {
    COMMUNITY_ID: "community", // branded community uuid
};

export { EXLY_WEBAPP_URL_SEARCH_PARAMS };
//# sourceMappingURL=url.js.map
